import { render, staticRenderFns } from "./DailyDiscountList.vue?vue&type=template&id=0cebf116"
import script from "./DailyDiscountList.vue?vue&type=script&lang=js"
export * from "./DailyDiscountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports